export default ".flex-col {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}";